<template>
  <v-card flat>
    <v-card-title
      primary-title
      class="pa-0 font-weight-bold mb-12 justify-center display-1 letter-spacing-normal"
    >
      Forgot your password?
    </v-card-title>
    <ValidationObserver ref="validator">
      <v-form @submit.prevent="submit()">
        <ValidationProvider
          rules="required|email"
          name="email"
          required
          v-slot="{ errors }"
        >
          <v-text-field
            name="email"
            label="Email"
            class="white mb-8"
            v-model="request.email"
            :error-messages="errors"
          />
        </ValidationProvider>
        <v-btn
          type="submit"
          depressed
          block
          large
          color="primary"
          class="font-weight-bold mb-5 title"
          @click.prevent="submit()"
        >
          Send an email
        </v-btn>
        <v-btn
          text
          block
          large
          color="primary"
          class="font-weight-bold mb-5 title"
          :to="{ name: 'login' }"
        >
          Go to Login
        </v-btn>
      </v-form>
    </ValidationObserver>
  </v-card>
</template>

<script>
import Request from '@request/Auth/ForgotPasswordRequest';

export default {
  name: 'ForgotPassword',
  metaInfo: {
    titleTemplate: '%s - Forgot Password',
  },
  data() {
    return {
      showPassword: false,
      request: new Request(this.$refs, {
        email: '',
      }),
    };
  },
  methods: {
    async submit() {
      if (await this.$refs.validator.validate()) {
        await this.request.submit();
      }
    },
  },
  mounted() {
    this.request.$validator = this.$refs.validator;
  },
};
</script>
